import React, { useEffect } from "react";

export default function Pricing() {
  const destination = "https://staging.sofmat.it/#sfl-1-pacchetti";
  useEffect(() => { window.location.replace(destination); }, []);
  return <main className="p-8"><p>Apri il listino SOFMAT aggiornato.</p><a className="underline" href={destination}>Confronta Base, Premium, Business ed Enterprise →</a></main>;
}
